export default __webpack_public_path__ + "static/media/baby.4663af19.png";